<template>
    <b-card v-bind:header="$t('createShipment.label.Pickup')" class="mb-2">
        <b-col sm="12">
            <b-row v-if="pickup.bookPickup && !shouldHideTimeslot">
                <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.Ready Time')"
                        label-align-sm="left"
                    >
                        <b-input-group size="sm">
                            <b-col sm="10">
                                <v-select
                                    :options="getReadyBookingTimes"
                                    :placeholder="
                                        $t('createShipment.placeholder.Choose Ready Time')
                                    "
                                    name="readyTimeDropdown"
                                    v-model="pickup.readyTime"
                                    :clearable="false"
                                    @input="updateShipment"
                                    :dynamicWidth="false"
                                />
                            </b-col>
                            <b-input-group-append>
                                <div>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group
                        label-cols-sm="3"
                        :label="$t('createShipment.label.Close Time')"
                        label-align-sm="left"
                    >
                        <b-input-group size="sm">
                            <b-col sm="10">
                                <v-select
                                    :options="getCloseBookingTimes"
                                    :placeholder="
                                        $t('createShipment.placeholder.Choose Close Time')
                                    "
                                    name="closeTimeDropdown"
                                    v-model="pickup.closeTime"
                                    :clearable="false"
                                    @input="updateShipment"
                                    :dynamicWidth="false"
                                />
                            </b-col>
                            <b-input-group-append>
                                <div>
                                    <font-awesome-icon
                                        icon="exclamation-circle"
                                        size="lg"
                                    />
                                </div>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="6">
                    <b-form-group
                        label-cols-sm="4"
                        :label="$t('createShipment.label.Book Pickup')"
                        label-align-sm="left"
                    >
                        <b-input-group size="sm">
                            <b-col sm="10">
                                <b-form-checkbox
                                    class="float-left"
                                    size="sm"
                                    v-model="pickup.bookPickup"
                                    @change="resetPickup"
                                    name="bookPickupCheckbox"
                                />
                            </b-col>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="shipmentSystem === 'YOYOUnitedStates'">
              <b-col sm="12">
                FedEx Ground pickups can be booked for next business day. If booked for today, the shipment will be postdated to next business day.
              </b-col>
            </b-row>
        </b-col>
    </b-card>
</template>
<script>
  import vSelect from './vSelect';
  import 'vue-select/dist/vue-select.css';
  import { format } from 'date-fns';
  import {mapGetters} from "vuex";
  import viewOptions from "@/mixins/viewOptionsMixin";
  import localization from "@/mixins/localizationMixin";
  import resetMixin from "@/mixins/resetMixin";
  export default {
      props: {
          shipment: { type: Object, required: true },
          defaultValues: { type: Object , required: true },
      },
      components: {
          vSelect,
      },
      data() {
          return {
              pickup: {
                  bookPickup: true,
                  readyTime: '06:00',
                  closeTime: '17:00',
              },
              bookingTimes: [
                  '04:00',
                  '05:00',
                  '06:00',
                  '07:00',
                  '08:00',
                  '09:00',
                  '10:00',
                  '11:00',
                  '12:00',
                  '13:00',
                  '14:00',
                  '15:00',
                  '16:00',
                  '17:00',
                  '18:00',
                  '19:00',
                  '20:00',
                  '21:00',
                  '22:00',
                  '23:00',
              ],
          };
      },
      mounted() {
        if (this.shipment.shipmentType == "Import" && !this.defaultValues.defaultImportPickup) {
          this.pickup.bookPickup = false;
        } else if (this.shipmentSystem == 'YOYONorway') {
          this.pickup.bookPickup = false;
        }
        this.updateShipment();
      },

      beforeDestroy() {
          this.shipment.pickup = null;
      },
      methods: {
          bookPickup(){
            this.pickup.bookPickup = true;
            this.updateShipment();
          },
          updateShipment() {
              this.shipment.pickup = null;
              if (this.pickup.bookPickup) {
                  this.shipment.pickup = {
                      readyTime: this.pickup.readyTime,
                      closeTime: this.pickup.closeTime,
                  };
              }
          },

          resetPickup() {
              if (!this.pickup.bookPickup) {
                  this.shipment.pickup = {
                      readyTime: this.pickup.readyTime,
                      closeTime: this.pickup.closeTime,
                  };
              } else {
                  this.shipment.pickup = null;
              }
          },
      },
      computed: {
          shouldHideTimeslot(){
            if (this.shipment.shipmentType == 'Export' && this.shipmentSystem == 'YOYONorway'){
              return true;
            }
            return false;
          },
          shipmentSystem(){
            return this.$store.state.core.shipmentSystem;
          },
          getBookingTimes() {
              return this.bookingTimes;
          },
          getCloseBookingTimes() {
              const readyTime = this.pickup.readyTime;
              const result = [];
              this.bookingTimes.forEach((element) => {
                  if (element > readyTime) {
                      result.push(element);
                  }
              });

              return result;
          },

          getReadyBookingTimes() {
              const closeTime = this.pickup.closeTime;
              const result = [];
              this.bookingTimes.forEach((element) => {
                  if (element < closeTime) {
                      result.push(element);
                  }
              });

              return result;
          },
      },
  };
</script>
